function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import styled, { css } from 'styled-components';
import React from 'react';
import { getColorPalette, getTypography, TypographyName } from '../../theme';
/**
* Classic use of styled because `css` attribute is not transpiled
*/
const CustomTag = styled.div.withConfig({
  displayName: "Typography__CustomTag",
  componentId: "sc-1yp7xnl-0"
})(["", ""], _ref => {
  let {
    theme,
    $type,
    $color,
    $textAlign,
    $uppercase,
    $fontWeight,
    $lineHeight
  } = _ref;
  return css(["", " color:", ";text-align:", ";", ""], getTypography(theme, $type || TypographyName.BODY, {
    fontWeight: $fontWeight,
    lineHeight: $lineHeight
  }), getColorPalette(theme, $color || 'neutrals.darkest'), $textAlign || 'inherit', $uppercase && `
      text-transform: uppercase;
    `);
});
const TypographyText = _ref2 => {
  let {
    color,
    tagName,
    type,
    textAlign,
    uppercase = false,
    fontWeight,
    lineHeight,
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(CustomTag, {
    as: tagName,
    $type: type,
    $textAlign: textAlign,
    $color: color,
    $uppercase: uppercase,
    $fontWeight: fontWeight,
    $lineHeight: lineHeight
  }, children);
};
export const Typography = _ref3 => {
  let {
    children
  } = _ref3;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-useless-fragment
    React.createElement(React.Fragment, null, children)
  );
};
Typography.MEGA = props => /*#__PURE__*/React.createElement(TypographyText, _extends({
  tagName: "h1"
}, props, {
  type: TypographyName.MEGA
}));
Typography.H1 = props => /*#__PURE__*/React.createElement(TypographyText, _extends({
  tagName: "h1"
}, props, {
  type: TypographyName.H1
}));
Typography.H2 = props => /*#__PURE__*/React.createElement(TypographyText, _extends({
  tagName: "h2"
}, props, {
  type: TypographyName.H2
}));
Typography.H3 = props => /*#__PURE__*/React.createElement(TypographyText, _extends({
  tagName: "h3"
}, props, {
  type: TypographyName.H3
}));
Typography.H4 = props => /*#__PURE__*/React.createElement(TypographyText, _extends({
  tagName: "h4"
}, props, {
  type: TypographyName.H4
}));
Typography.BODY = props => /*#__PURE__*/React.createElement(TypographyText, _extends({
  tagName: "div"
}, props, {
  type: TypographyName.BODY
}));
Typography.SMALL = props => /*#__PURE__*/React.createElement(TypographyText, _extends({
  tagName: "small"
}, props, {
  type: TypographyName.SMALL
}));
Typography.SMALLER = props => /*#__PURE__*/React.createElement(TypographyText, _extends({
  tagName: "small"
}, props, {
  type: TypographyName.SMALLER
}));
export default Typography;
//# sourceMappingURL=Typography.js.map